import {
  IBooleanResponse,
  ICallCreatedInfo,
  ICallCreateProps,
  ICreateRoomResult,
} from '@gem/call/Model/callModel.types';
import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import {
  createCallRequest,
  createRoomRequest,
  declineCallRequest,
} from 'APP/wsApi/wsAppApi/requests/callRequests';

import { mapInitialParticipants } from './mainCallModel.mapper';
import { ICreateRoomParams } from './mainCallModel.types';

export const createCall = async (props: ICallCreateProps): Promise<ICallCreatedInfo> => {
  try {
    const result = await createCallRequest({
      chatId: BigInt(props.groupId!),
    });

    if (result.type.case === 'success') {
      const callInfo = result.type.value;

      return callInfo;
    } else {
      throw new Error('Unexpected error');
    }
  } catch (error) {
    logger.get('API').error('calls.createCall', error);
    throw buildModelError(error);
  }
};

export async function createRoom(params: ICreateRoomParams): Promise<ICreateRoomResult | null> {
  try {
    const result = await createRoomRequest({
      ...params,
      initialParticipants: mapInitialParticipants(params.initialParticipants),
    });

    if (result.type.case === 'success') {
      return { link: result.type.value.link, channelId: result.type.value.channelId };
    } else {
      return null;
    }
  } catch (error) {
    logger.get('API').error('calls.createRoom', error);
    throw buildModelError(error);
  }
}

export const declineCall = async (
  channelId: string,
  reason?: string
): Promise<IBooleanResponse> => {
  const result = await declineCallRequest({
    channelId,
    reason,
  });

  return { result: result.type.case === 'success' };
};
